var _path, _path2, _path3, _path4, _line, _line2, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTopbar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 27,
    viewBox: "0 0 23 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 9.53125C15.8665 9.53125 19.4062 7.60048 19.4062 5.21875C19.4062 2.83702 15.8665 0.90625 11.5 0.90625C7.1335 0.90625 3.59375 2.83702 3.59375 5.21875C3.59375 7.60048 7.1335 9.53125 11.5 9.53125Z",
    stroke: "#333333",
    strokeWidth: 1.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.59375 9.53125V13.8438C3.59375 16.2255 7.1335 18.1562 11.5 18.1562C15.8665 18.1562 19.4062 16.2255 19.4062 13.8438V9.53125",
    stroke: "#333333",
    strokeWidth: 1.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.59375 5.21875V9.53125C3.59375 11.913 7.1335 13.8438 11.5 13.8438C15.8665 13.8438 19.4062 11.913 19.4062 9.53125V5.21875",
    stroke: "#333333",
    strokeWidth: 1.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.59375 13.8438V18.1562C3.59375 20.538 7.1335 22.4688 11.5 22.4688C15.8665 22.4688 19.4062 20.538 19.4062 18.1562V13.8438",
    stroke: "#333333",
    strokeWidth: 1.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 22.2812,
    y1: 7.375,
    x2: 22.2812,
    y2: 19.5938,
    stroke: "#333333",
    strokeWidth: 1.4375
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.71875,
    y1: 7.375,
    x2: 0.718751,
    y2: 19.5937,
    stroke: "#333333",
    strokeWidth: 1.4375
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2812 7.375C22.2812 9.02253 21.2108 10.6228 19.2508 11.8478C17.3009 13.0665 14.5625 13.8437 11.5 13.8437C8.43752 13.8437 5.69907 13.0665 3.74921 11.8478C1.78921 10.6228 0.71875 9.02253 0.71875 7.375C0.71875 5.72747 1.78921 4.12717 3.74921 2.90217C5.69907 1.6835 8.43752 0.90625 11.5 0.90625C14.5625 0.90625 17.3009 1.6835 19.2508 2.90217C21.2108 4.12717 22.2812 5.72747 22.2812 7.375Z",
    stroke: "#333333",
    strokeWidth: 1.4375
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2812 19.5938C22.2812 21.0051 21.2567 22.4292 19.2794 23.5414C17.3245 24.641 14.5756 25.3438 11.5 25.3438C8.42442 25.3438 5.67547 24.641 3.72065 23.5414C1.7433 22.4292 0.71875 21.0051 0.71875 19.5938C0.71875 18.2124 1.70189 16.8179 3.59375 15.7186V17.4375C3.59375 19.4054 4.76114 20.6946 6.29446 21.4512C7.79816 22.1932 9.71878 22.4687 11.5 22.4687C13.7485 22.4687 15.6673 22.0014 17.0503 21.2605C18.3939 20.5407 19.4062 19.4532 19.4062 18.1562V15.7282C21.456 16.812 22.2812 18.0955 22.2812 19.5938Z",
    stroke: "#333333",
    strokeWidth: 1.4375
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopbar);
export default __webpack_public_path__ + "static/media/topbar.56977ff8.svg";
export { ForwardRef as ReactComponent };